import clsx from 'clsx'

/** Iniciály ze jména („Jan Novák" → „JN"). */
export function initialsOf(name?: string | null): string {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}

/** Je barva tmavá (bílý text) nebo světlá (tmavý text)? Pro barvy pracovníků z DB. */
function isDark(hex: string): boolean {
  const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim())
  if (!m) return true
  const n = parseInt(m[1], 16)
  const [r, g, b] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].map((c) => {
    const s = c / 255
    return s <= 0.03928 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4
  })
  const lum = 0.2126 * r + 0.7152 * g + 0.0722 * b
  // Kontrast s bílou ≥ 3 : 1 (velké tučné písmo) → bílé písmo.
  return 1.05 / (lum + 0.05) >= 3
}

const SIZES = {
  xs: 'h-7 w-7 text-xs',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-sm',
  lg: 'h-12 w-12 text-base',
}

/**
 * Kolečko s iniciálami v barvě uživatele (z profilu). Jméno je vždy v `aria-label`;
 * kde na jménu záleží, ukaž ho i jako text vedle — avatar sám jméno neprozradí.
 */
export function Avatar({
  name,
  initials,
  color,
  size = 'sm',
  ring = false,
  className,
}: {
  name?: string | null
  initials?: string | null
  color?: string | null
  size?: keyof typeof SIZES
  /** Zvýraznění (např. „já"). */
  ring?: boolean
  className?: string
}) {
  const bg = color || '#6D6D6D'
  return (
    <span
      role="img"
      aria-label={name ?? undefined}
      className={clsx(
        'inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold leading-none',
        SIZES[size],
        ring && 'ring-2 ring-brand-500 ring-offset-2 ring-offset-white',
        className,
      )}
      style={{ backgroundColor: bg, color: isDark(bg) ? '#fff' : '#1C1C1C' }}
    >
      {initials || initialsOf(name)}
    </span>
  )
}
